import store from '../store'
import {
  NOT_AUTH,
  AUTH_COMPLETE,
  AUTH_UNBIND,
  AUTH_UNDER_APPEAL,
  AUTH_APPEAL_FAIL,
  AUTH_UNKOWN
} from './const'
import { urlObj } from './url'
import { oMegaData } from 'common-js/omega'
import { defaultBiz, defaultBizCode } from '../config/utils'

export const name_verify_route = {
  [NOT_AUTH]: 'lotNames',
  [AUTH_COMPLETE]: 'index',
  [AUTH_UNBIND]: 'Confirm',
  [AUTH_UNDER_APPEAL]: 'verifyIng',
  [AUTH_APPEAL_FAIL]: 'verifyFail',
  [AUTH_UNKOWN]: '',
}

/**
 * 去实名清除页面
*/
export function goClearNamePage() {
  const { biz, lang, biz_code }   = window.GlobalSet.query
  let renameBiz = biz || defaultBiz()
  let renameLang = lang || 'zh-CN'
  let bizCode = biz_code || defaultBizCode()
  location.replace(`${urlObj.clearNamePage}?biz=${renameBiz}&faceBizCode=${bizCode}&lang=${renameLang}`)
}

/**
 * 实名页面（nameID）、首页（index）、实名确认页（lotNames）埋点属性
 * 包含手机号，实名身份证、环境等信息
*/
export function sendOmega(name, omegaAttrs) {
  const { env, identityCards } = store.getters
  const commonParams = {
    env,
    roleSum: identityCards.length || 1,
    biz: window.GlobalSet.query.biz || defaultBiz(),
  }
  const params = Object.assign({}, commonParams, omegaAttrs)
  oMegaData(name, params)
}
